export const ROUTER_BASE_URL = `/`;
export const WEBMSG_ENDPOINT = "webmsg_command";
export const WEBADMIN_ENDPOINT = "webadmin_command";
